// extracted by mini-css-extract-plugin
module.exports = {"shield":"dece2e673c--shield--TsFnA"};